import { useState, useEffect } from 'react';

const useAuthentication = () => {
    const [validToken, setValidToken] = useState(null); // null = loading, true = valid, false = invalid

    useEffect(() => {
        const checkTokens = () => {
            const accessToken = localStorage.getItem("accessToken");
            const refreshToken = localStorage.getItem("refreshToken");
            
            // If we have either token, consider user potentially authenticated
            // The interceptor will handle the actual validation
            if (accessToken || refreshToken) {
                setValidToken(true);
            } else {
                setValidToken(false);
            }
        };

        // Listen for auth failures from interceptor
        const handleAuthFailure = () => {
            setValidToken(false);
        };

        checkTokens();
        window.addEventListener('auth-failed', handleAuthFailure);

        return () => {
            window.removeEventListener('auth-failed', handleAuthFailure);
        };
    }, []);

    // Function to manually logout
    const logout = () => {
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        setValidToken(false);
        window.location.href = "/signin";
    };

    // Function to set authenticated state after login
    const setAuthenticated = (accessToken, refreshToken) => {
        localStorage.setItem("accessToken", accessToken);
        localStorage.setItem("refreshToken", refreshToken);
        setValidToken(true);
    };

    return { 
        validToken, 
        isLoading: validToken === null,
        logout, 
        setAuthenticated 
    };
};

export default useAuthentication;